import React from "react"
import { createStackNavigator } from "@react-navigation/stack"
import MultiFactorSelect from "../../auth/multifactor-select"
import MFA from "../../auth/multifactor-auth"
import EmailVerification from "../../auth/email-verification"
import CollectName from "../../auth/collect-name"

const Stack = createStackNavigator()

const MfaStack = () => {
  return (
    <Stack.Navigator screenOptions={{ headerShown: false, gestureEnabled: false }} id={undefined}>
      <Stack.Screen name="VerifyEmail" component={EmailVerification} />
      <Stack.Screen name="ConfigureMfa" component={MultiFactorSelect} />
      <Stack.Screen name="VerifyMfa" component={MFA} />
      <Stack.Screen name="CollectName" component={CollectName} />
    </Stack.Navigator>
  )
}

export default MfaStack


